import { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import CanonicalTag from '../components/CanonicalTag';
import { Button } from '../components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '../components/ui/dialog';

// Portfolio images from Unsplash
const portfolioImages = ["https://images.unsplash.com/photo-1721322800607-8c38375eef04?w=800&h=600&fit=crop", "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop", "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?w=800&h=600&fit=crop"];
const HowToUseADUForCouplesOrRoommates = () => {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/how-to-use-adu-for-couples-or-roommates" />
      <Navigation />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-6xl font-bold mb-6 text-brand">
                How to Use Your ADU for Couples or Roommates
              </h1>
            </div>
            
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand">
                  Shared Living That Actually Works
                </h2>
                <p className="text-xl mb-8 text-gray-400">
                  Whether it's for newlyweds saving for a home or roommates splitting rent, an ADU gives two people their own peaceful place to live affordably—without sacrificing comfort, privacy, or style.
                </p>
                <div className="flex flex-wrap gap-4">
                  <Button onClick={() => setIsCalendlyOpen(true)} size="lg" className="bg-brand hover:bg-brand/90 text-white">
                    📅 Book & Schedule
                  </Button>
                  <Button onClick={() => window.location.href = '/landing'} variant="outline" size="lg" className="border-brand text-brand hover:bg-brand hover:text-white">
                    💰 Get your price & ROI report
                  </Button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <img src={portfolioImages[0]} alt="Modern ADU interior for couples" className="w-full h-64 object-cover rounded-lg" />
                <img src={portfolioImages[1]} alt="Private bathroom space" className="w-full h-64 object-cover rounded-lg" />
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 px-4 bg-secondary/10">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <img src={portfolioImages[2]} alt="Open living and kitchen area" className="w-full h-96 object-cover rounded-lg" />
              <div>
                <h3 className="text-3xl font-bold mb-6 text-brand">
                  Features to Highlight
                </h3>
                <div className="space-y-4 text-foreground bg-zinc-50">
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-brand rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-foreground">Dual closets or split-layout bedrooms</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-brand rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-foreground">Sound-insulated walls</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-brand rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-foreground">Separate entry + shared living/kitchen</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-brand rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-foreground">Private patio or outdoor chill zone</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section id="cta-section" className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-2xl mb-12 text-white">
              Modern co-living starts with smart design. We'll help you build an ADU everyone can feel at home in.
            </p>
            
            <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
              <Button onClick={() => setIsCalendlyOpen(true)} size="lg" className="bg-brand hover:bg-brand/90 text-white">
                📅 Book & Schedule
              </Button>
              <Button variant="outline" size="lg" className="border-brand text-brand hover:bg-brand hover:text-white" onClick={() => window.location.href = '/landing'}>
                📐 What fits my lot?
              </Button>
              <Button variant="outline" size="lg" className="border-brand text-brand hover:bg-brand hover:text-white" onClick={() => window.location.href = '/landing'}>
                💰 Get your price & ROI report
              </Button>
              <Button variant="outline" size="lg" className="border-brand text-brand hover:bg-brand hover:text-white" onClick={() => window.location.href = '/our-work'}>
                🏡 Our Portfolio
              </Button>
              <Button variant="outline" size="lg" className="border-brand text-brand hover:bg-brand hover:text-white" onClick={() => window.location.href = '/faq'}>
                ❓ Our FAQ
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Calendly Modal */}
      <Dialog open={isCalendlyOpen} onOpenChange={setIsCalendlyOpen}>
        <DialogContent className="max-w-4xl w-full h-[80vh]">
          <iframe src="https://calendly.com/udaadu" width="100%" height="100%" frameBorder="0" title="Schedule a consultation"></iframe>
        </DialogContent>
      </Dialog>
    </div>;
};
export default HowToUseADUForCouplesOrRoommates;